import { Booking } from 'components/EventCalendar/types';
import { Form } from 'components/Form/base/Form';
import { FormInput } from 'components/Form/next';
import Loader from 'components/Loader';
import { usePaymentStatus } from 'components/MollieConnect/hooks';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useApi } from '../../../hooks/useApi';

interface Props {
    booking: Booking;
    callback?: (data: Booking) => void;
}

export const UpdatePriceForm = ({ booking, callback }: Props) => {
    const api = useApi();
    const { t } = useTranslation('bookings');
    const { data, error } = usePaymentStatus(booking.payment_id);
    const [isLoading, setIsLoading] = useState(false);
    const isLoadingPayment = booking.payment_id && !data && !error;

    const handleSubmit = (data) => {
        setIsLoading(true);
        return api({
            url: `booking/${booking.id}/update-price`,
            method: 'PUT',
            data,
            onBefore: () => setIsLoading(false),
            onSuccess: ({ data }) => callback?.(data)
        });
    };

    const amountRemaining = Number(data?.amountRemaining?.value);
    const amount = Number(data?.amount?.value);

    return (
        <Loader isLoading={isLoadingPayment}>
            <Form
                onSubmit={handleSubmit}
                setDefaultValuesOnRerender={false}
                defaultValues={{ payment_refund_value: amount }}
            >
                <FormInput
                    type="number"
                    step={0.01}
                    max={amountRemaining}
                    name="price"
                    label={t('booking.updatePrice.priceLabel')}
                />
                <FormInput.Submit isLoading={isLoadingPayment || isLoading} color="warning">
                    {t('booking.updatePrice.submit')}
                </FormInput.Submit>
            </Form>
        </Loader>
    );
};
